import { useState, useCallback } from "react";
import cn from "classnames";

import Select from "../../FormElements/Select";
import { SelectChangeResult } from "../../FormElements/Select/Select.props";
import Button from "../../Button";
import { TableBulkActionProps } from "../Table.props";

import styles from "./BulkActions.module.scss";

/**
 * @deprecated
 */
function CreateBulkAction<T>(props: TableBulkActionProps<T>): JSX.Element {
  const { bulkActions, handleBulkActionsApply, paginate } = props;

  const [selectedFunction, setSelectedFunction] = useState("");

  const bulkActionContainerClass = cn({ [styles["table-bulk-action-container"]]: !paginate });

  const applyClickHandler = useCallback(() => {
    handleBulkActionsApply(selectedFunction);
  }, [selectedFunction]);

  const bulkActionChangeHandler = useCallback((value: SelectChangeResult) => {
    if (typeof value === "string") setSelectedFunction(value);
    else setSelectedFunction("");
  }, []);

  return (
    <div className={bulkActionContainerClass}>
      <div>
        <Select
          id="bulkactions"
          name="bulkactions"
          placeholder="Bulk Actions"
          inputExtraClass="bulk-action-select"
          containerExtraClass={styles["paginate-select"]}
          onChange={bulkActionChangeHandler}
        >
          {Object.keys(bulkActions).map((opt: string, idx: number) => (
            <option value={opt} key={`opt-${idx}`}>
              {opt}
            </option>
          ))}
        </Select>
      </div>
      <div data-testid="test__apply_bulk_actions">
        <Button id={"apply-btn"} size="small" type="submit" tier="secondary" onClick={applyClickHandler}>
          Apply
        </Button>
      </div>
    </div>
  );
}

/**
 * @deprecated
 */
export default CreateBulkAction;
